import { render, staticRenderFns } from "./ApprovePayment.vue?vue&type=template&id=88d29e14&"
import script from "./ApprovePayment.vue?vue&type=script&lang=js&"
export * from "./ApprovePayment.vue?vue&type=script&lang=js&"
import style0 from "./ApprovePayment.vue?vue&type=style&index=0&id=88d29e14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports